import React from 'react';
import { motion } from 'framer-motion';
import { tomos } from '../data/salesData';
export function TomosSection() {
  return <section className="py-16 px-4 bg-surface-light" data-id="element-189" data-mp="1kbivzgsxx8j5">
      <div className="max-w-6xl mx-auto" data-id="element-190" data-mp="1p3twakrlewc8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-191" data-mp="1p4v6kn0sbesw">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-192" data-mp="11f0x8ffoc8de">
            Los 12 Tomos Completos
          </h2>
          <p className="text-lg text-gray-600" data-id="element-193" data-mp="16brbqybtyvwp">
            Secuencias graficadas · Por nivel y objetivo · Listo para usar
            mañana
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-194" data-mp="2hr6ao7nlnxug">
          {tomos.map((tomo, index) => <motion.div key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.1
        }} className={`p-6 rounded-lg border-2 ${index % 2 === 0 ? 'bg-white border-gray-200' : 'bg-surface-accent border-gray-200'}`} data-id="element-195" data-mp="2mq10htjzimo2" data-mpi={index}>
              <div className="flex items-start gap-4" data-id="element-196" data-mp="22yec5gj8iu59">
                <div className="w-12 h-12 rounded-lg bg-primary text-white flex items-center justify-center font-bold text-xl flex-shrink-0" data-id="element-197" data-mp="22wtc5be5ij00">
                  {tomo.number}
                </div>
                <div className="flex-1" data-id="element-198" data-mp="1tw4yihso6knn">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-199" data-mp="1oz4usdjaltzp">
                    TOMO {tomo.number}
                  </h3>
                  <h4 className="text-lg font-semibold text-accent mb-2" data-id="element-200" data-mp="1k0k3x4pxkmnx">
                    {tomo.title}
                  </h4>
                  {tomo.weeks && <p className="text-sm text-gray-500 font-medium mb-2" data-id="element-201" data-mp="1fbiyrrpdhez6">
                      ({tomo.weeks})
                    </p>}
                  <p className="text-gray-700" data-id="element-202" data-mp="11dui6w2c8tzx">{tomo.description}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center bg-white p-6 rounded-xl shadow-sm" data-id="element-203" data-mp="1t3yvkarokgrn">
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-204" data-mp="2c1jk1gqj9dbq">
            <span data-id="element-205" data-mp="2bzp0a5qzzr98">✏️</span>
            <span className="text-sm font-semibold" data-id="element-206" data-mp="2gs03piky5v6j">
              Ejercicios graficados en cada tomo
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-207" data-mp="5bydu5barfwo">
            <span data-id="element-208" data-mp="ey67pysu53g">⚡</span>
            <span className="text-sm font-semibold" data-id="element-209" data-mp="dn3zul055eg">
              Sistema "Abre y Dicta"
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-210" data-mp="f4x55uy6hkjz">
            <span data-id="element-211" data-mp="a4rjcvelas9t">📋</span>
            <span className="text-sm font-semibold" data-id="element-212" data-mp="3ijt5u3uz2e2p">
              Fichas listas para imprimir
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-800" data-id="element-213" data-mp="3dlhvzt4og3kh">
            <span data-id="element-214" data-mp="3shpg6tg354zr">🎯</span>
            <span className="text-sm font-semibold" data-id="element-215" data-mp="3sj0ggjabnum4">
              Contenido 100% listo para aplicar
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}